import { connect } from 'react-redux';
import React from 'react';
import { showApiError } from 'utils/feedback';
import {
KBFormError,
KBButton,
KBImageCropperInput } from
'components';
import { Field, reduxForm } from 'redux-form';
import { Select } from 'antd';
import * as valid from 'utils/validate';
const demoImg = require('styles/images/qrcode-demo.jpg');

var GroupSetValueAddedServices = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);this.failureCallBack = this.failureCallBack.bind(this);this.renderEmails = this.renderEmails.bind(this);this.renderQiyechatImage = this.renderQiyechatImage.bind(this);}
  updateSpace(

  model) {
    const { updateLocationSetting } = this.props;
    return updateLocationSetting(
    {
      value_added_service_settings: model },

    { key: 'value_added_service_settings' });

  }failureCallBack(

  err) {
    if (!err) return;
    return showApiError('上传失败', err);
  }renderEmails(

  { input, meta }) {
    return (
      <div>
        <Select
        mode="tags"
        showSearch
        style={{ width: '100%' }}
        onChange={input.onChange}
        value={input.value || []}>

          {/* {emailList.map(item => {
             return (
               <Option key={item.id} value={item.email}>
                 {item.email}
               </Option>
             )
            })} */}
        </Select>
        {meta.touched && meta.error && <p className="lr-error">{meta.error}</p>}
      </div>);

  }renderQiyechatImage(

  { input, meta }) {
    const qiyechatImage = {
      value: input.value,
      touched: meta.touched,
      error: meta.error,
      onChange: input.onChange };
    return (
      <KBImageCropperInput
      aspect={1}
      isRequired
      className="kb-form-group kb-form-210 kb-form-alone"
      field={qiyechatImage}
      type="origanizations"
      accept="image/jpeg, image/png"
      imageSize={1024 * 10}
      failureCallBack={this.failureCallBack}
      isPublic>

        <div className="upload-portrait">
          {qiyechatImage.value &&
          <img
          alt="failed"
          src={qiyechatImage.value}
          style={{
            width: '100px',
            height: '100px',
            display: 'inline-block',
            marginLeft: 0 }} />}



          <button className="bordered-btn" type="button">
            上传图片
          </button>
        </div>
      </KBImageCropperInput>);

  }render()

  {
    const { handleSubmit, setting, submitting } =
    this.props;
    if (!setting) {
      return null;
    }

    return (
      <div className="nav-section-content-container" style={{ padding: 0 }}>
        <header className="nav-header">
          <div className="nav-section-header-title">
            <span>增值服务设置</span>
          </div>
        </header>
        <div className="kb-form-container">
          <form onSubmit={handleSubmit(this.updateSpace)}>
            <KBFormError error={this.props.error} />
            <div className="kb-form-container" style={{ padding: 0 }}>
              <fieldset className="fieldset">
                <legend>邮件发送列表</legend>
                <Field name="emails" component={this.renderEmails} />

              </fieldset>

              <fieldset
              className="fieldset"
              style={{ display: 'inline-block' }}>

                <legend>企业微信二维码</legend>
                <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between' }}>

                  <Field name="qiyechat_image" component={this.renderQiyechatImage} />
                  <div
                  style={{
                    paddingRight: '60px',
                    color: '#999999',
                    textAlign: 'center' }}>


                    <p>样例二维码</p>
                    <img src={demoImg} alt="demo" style={{ width: '100px' }} />
                  </div>
                </div>
                <p
                className="color-nine"
                style={{
                  paddingTop: '20px',
                  fontSize: '12px' }}>


                  图片格式为png,
                  jpeg或jpg,文件大小不大于10M，请不要上传不带边框修饰的二维码，以上样例供参考
                </p>
              </fieldset>

              <div className="kb-row m-top">
                <KBButton
                className="certain-btn"
                type="submit"
                submitting={submitting}>

                  保存
                </KBButton>
              </div>
            </div>
          </form>
        </div>
      </div>);

  }};


function mapStateToProps(state, props) {
  const { groupSetting } = state;
  let setting_value = groupSetting.value_added_service_settings;
  return {
    initialValues: {
      ...setting_value } };


}

const validate = values => {
  const errors = {};

  if (!values.emails || values.emails.length === 0) {
    errors.emails = '请输入邮件发送列表';
  }

  const allAreEmail = (values.emails || []).every(i => !valid.email(i));
  if (!allAreEmail) {
    errors.emails = '请验证输入的邮箱';
  }

  return errors;
};

const formConfig = {
  form: 'GroupSetValueAddedServices',
  validate: validate,
  touchOnBlur: false,
  enableReinitialize: true };

GroupSetValueAddedServices = reduxForm(formConfig)(GroupSetValueAddedServices);

export default connect(mapStateToProps)(GroupSetValueAddedServices);
